import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import App from "./App";
import { initCrashReporter, setCrashContext } from "./lib/crash";
import { useGame } from "./game/store";
import "./index.css";

setCrashContext(() => {
  const s = useGame.getState();
  return { phase: s.phase, distance: Math.floor(s.distance), difficulty: s.difficulty };
});
initCrashReporter();

async function bootNativeChrome() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: "#070B18" });
  } catch {
    /* web / unsupported */
  }
}
void bootNativeChrome();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
